<template>
  <div class="app-wrapper bg-white h-100">
    <div class="app-main">
      <div class="app-content p-0">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1 w-100 d-flex align-items-center">
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-md-6 pl-0 d-none d-sm-flex align-items-center hide-image img-banner-left"
                >
                  <div class="wrap" :style="wrapStyle">
                    <img
                      src="../../assets/img/inisiasi.jpg"
                      :style="wrapImgStyle"
                      alt="initial page izidok"
                    />
                  </div>
                </div>
                <div
                  class="col-md-6 d-flex justify-content-center align-self-center content-register-right"
                >
                  <div
                    class="col-sm-11 pt-0 __zoom-survey"
                    style="margin-left:auto;margin-right:auto;font-size:14px;"
                  >
                    <h5 class="font-weight-bold mb-3" style="color:#064FAF">
                      Isi survey berikut:
                    </h5>
                    <b-form-group label-for="input-1">
                      <label class="font-weight-bold" style="color:grey;"
                        >1. Berapa budget Anda untuk pembelian
                        obat-obatan/BHP/Bulan<span style="color:red">*</span
                        >?</label
                      >
                      <b-form-radio v-model="selectedBudget" value="0-5juta"
                        >0-5juta</b-form-radio
                      >
                      <b-form-radio
                        v-model="selectedBudget"
                        class="mt-1"
                        value="5-10juta"
                        >5-10juta</b-form-radio
                      >
                      <b-form-radio
                        v-model="selectedBudget"
                        class="mt-1"
                        value=">10 juta"
                        >>10juta</b-form-radio
                      >
                      <template v-if="selectedBudget == null && errorBudget">
                        <div class="mt-1">
                          <span for="" style="color:red"
                            >Kolom harus diisi</span
                          >
                        </div>
                      </template>
                    </b-form-group>
                    <b-form-group label-for="input-1">
                      <label class="font-weight-bold" style="color:grey;"
                        >2. Dimana biasanya Anda paling sering membeli
                        obat-obat/BHP<span style="color:red">*</span>?</label
                      >
                      <b-form-radio
                        v-model="selectedObat"
                        value="Shopee, Tokopedia, Ecommerce lainnya"
                        >Shopee, Tokopedia, Ecommerce lainnya</b-form-radio
                      >
                      <b-form-radio
                        v-model="selectedObat"
                        class="mt-1"
                        value=" Langsung melalui distributor farmasi"
                      >
                        Langsung melalui distributor farmasi</b-form-radio
                      >
                      <b-form-radio
                        v-model="selectedObat"
                        class="mt-1"
                        value="Apotek terdekat"
                        >Apotek terdekat</b-form-radio
                      >
                      <b-form-radio
                        v-model="selectedObat"
                        class="mt-1"
                        value="Lainnya"
                        >Lainnya, sebutkan:</b-form-radio
                      >
                      <template v-if="selectedObat == 'Lainnya'">
                        <div>
                          <b-form-input
                            class="mt-2"
                            style="height:30px"
                            maxlength="25"
                            v-model="selectedObatLainnya"
                          />
                          <template
                            v-if="
                              errorObat &&
                                (this.selectedObatLainnya == null ||
                                  this.selectedObatLainnya == '')
                            "
                          >
                            <div class="mt-1">
                              <span for="" style="color:red"
                                >Kolom harus diisi</span
                              >
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-if="selectedObat == null && errorObat">
                        <div class="mt-1">
                          <span for="" style="color:red"
                            >Kolom harus diisi</span
                          >
                        </div>
                      </template>
                    </b-form-group>
                    <b-form-group label-for="input-1">
                      <label class="font-weight-bold" style="color:grey;"
                        >3. Berapa kali biasanya Anda melakukan pembelian
                        obat/BHP<span style="color:red">*</span>?</label
                      >
                      <b-form-radio
                        v-model="selectedPembelian"
                        value="1-3x sebulan"
                        >1-3x/sebulan</b-form-radio
                      >
                      <b-form-radio
                        v-model="selectedPembelian"
                        class="mt-1"
                        value=">3x sebulan"
                        >>3x/sebulan</b-form-radio
                      >
                      <template
                        v-if="selectedPembelian == null && errorPembelian"
                      >
                        <div class="mt-1">
                          <span for="" style="color:red"
                            >Kolom harus diisi</span
                          >
                        </div>
                      </template>
                    </b-form-group>
                    <b-form-row>
                      <label
                        class="font-weight-bold col-md-12 "
                        style="color:grey;"
                        >4. Mohon sebutkan 5 obat yang paling sering Anda
                        beli<span style="color:red">*</span>!</label
                      >
                      <b-form-input
                        v-for="nol in 5"
                        :key="nol"
                        class="col-md-5 mb-2 ml-2"
                        style="height:30px"
                        maxlength="25"
                        v-model="formDataObat[nol - 1]"
                      ></b-form-input>
                      <template v-if="errorFormObat">
                        <div class="col-md-12 mb-1">
                          <span for="" style="color:red"
                            >Kolom harus diisi</span
                          >
                        </div>
                      </template>
                    </b-form-row>

                    <b-form-row label-for="input-1">
                      <label
                        class="font-weight-bold col-md-12"
                        style="color:grey;"
                        >5. Mohon sebutkan maks. 3 distributor farmasi langganan
                        Anda!</label
                      >
                      <b-form-input
                        v-for="nol in 3"
                        :key="nol"
                        class="col-md-5 mb-2 ml-2"
                        style="height:30px"
                        maxlength="25"
                        v-model="formDataDistributor[nol - 1]"
                      ></b-form-input>
                    </b-form-row>

                    <b-form-group label-for="input-1">
                      <label class="font-weight-bold" style="color:grey;"
                        >6. Kendala yang dialami saat melakukan pembelian
                        obat/BHP<span style="color:red">*</span>:</label
                      >
                      <br />
                      <b-form-textarea
                        id="textarea"
                        v-model="formDataPembelian"
                        placeholder="Contoh: stok sering habis, barang tidak original, dan lainya"
                        rows="3"
                        max-rows="6"
                        maxlength="100"
                      ></b-form-textarea>
                      <template v-if="errorFormDataPembelian">
                        <div class="mt-1">
                          <span for="" style="color:red"
                            >Kolom harus diisi</span
                          >
                        </div>
                      </template>
                    </b-form-group>

                    <button
                      type="submit"
                      @click="processUpdate"
                      class="btn btn-md btn-block text-capitalize mb-2"
                      style="background-color :#3F7EA7; color:white; border-radius : 10px;"
                    >
                      SELESAI
                    </button>
                    <a
                      @click="processUpdate"
                      class="btn btn-md btn-block text-capitalize mb-2"
                      style="cursor: pointer"
                    >
                      Lewati
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      windowHeight: 0,
      nol: 0,
      submitButton: false,
      selectedBudget: null,
      errorBudget: null,
      selectedObat: null,
      selectedObatLainnya: null,
      errorObat: null,
      selectedPembelian: null,
      errorPembelian: null,
      formDataObat: [],
      errorFormObat: false,
      formDataDistributor: [],
      formDataPembelian: null,
      errorFormDataPembelian: null
    };
  },
  watch: {
    selectedObat(val, preval) {
      if (preval == "Lainnya") {
        this.selectedObatLainnya = null;
      }
    },
    formDataPembelian(val) {
      if (val == null || val == "") {
        this.errorFormDataPembelian = true;
      } else {
        this.errorFormDataPembelian = false;
      }
    },
    formDataObat(val, preval) {
      if (
        this.formDataObat.includes("") ||
        (this.formDataObat.includes(undefined) && errorFormObat == true)
      ) {
        this.errorFormObat = true;
      } else {
        this.errorFormObat = false;
      }
    }
  },
  mounted() {
    if (localStorage.getItem("survey") == "false") {
      this.$router.push("/init-klinik");
    }

    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", e => {
        this.windowHeight = window.innerHeight;
      });
    });
  },
  computed: {
    ...mapGetters({
      getKlinikId: "getKlinikId",
      klinikUser: "klinikUser",
      faskes: "faskes",
      getRolesName: "getRolesName"
    }),
    wrapStyle() {
      return {
        height: this.windowHeight + "px"
      };
    },
    wrapImgStyle() {
      return {
        "max-height": this.windowHeight + "px"
      };
    },
    ...mapGetters({
      klinikUser: "klinikUser"
    })
  },
  methods: {
    ...mapMutations({
      collapseSidebar: "sidebar/SET_SIDEBAR_COLLAPSED",
      setInitPage: "sidebar/SET_INITIALIZATION_PAGE",
      setUserFirstLogin: "SET_USER_FIRST_LOGIN",
      setInitPosition: "SET_INIT_POSITION"
    }),
    processUpdate() {
      this.sendSurvey();
      return true;
      
      if (this.selectedBudget == null) {
        this.errorBudget = true;
      } else {
        this.errorBudget = false;
      }

      if (this.selectedPembelian == null) {
        this.errorPembelian = true;
      } else {
        this.errorPembelian = false;
      }

      if (this.selectedObat == null) {
        this.errorObat = true;
      } else if (
        this.selectedObat == "Lainnya" &&
        (this.selectedObatLainnya == null || this.selectedObatLainnya == "")
      ) {
        this.errorObat = true;
      } else {
        this.errorObat = false;
      }

      if (this.formDataObat.length == 5) {
        if (
          this.formDataObat.includes("") ||
          this.formDataObat.includes(undefined)
        ) {
          this.errorFormObat = true;
        } else {
          this.errorFormObat = false;
        }
      } else {
        this.errorFormObat = true;
      }

      if (this.formDataPembelian == "" || this.formDataPembelian == null) {
        this.errorFormDataPembelian = true;
      } else {
        this.errorFormDataPembelian = false;
      }

      if (
        !this.errorFormObat &&
        !this.errorObat &&
        !this.errorBudget &&
        !this.errorPembelian &&
        !this.errorFormDataPembelian
      ) {
        this.sendSurvey();
      } else {
        this.$swal({
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "warning",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false
        });
      }
    },
    async sendSurvey() {
      try {
        const paramPut = {
          klinik_id: this.getKlinikId,
          budget: this.selectedBudget,
          platform:
            this.selectedObat == "Lainnya"
              ? this.selectedObatLainnya
              : this.selectedObat,
          periode: this.selectedPembelian,
          obat: this.formDataObat,
          distributor_langganan: this.formDataDistributor,
          kendala: this.formDataPembelian
        };

        const res = await this.$axios.post(`survey`, paramPut);
        const { status } = res.data;

        if (status) {
          localStorage.setItem("survey", false);
          this.setInitPosition("klinik");
          this.$router.push("/init-klinik");
        }
      } catch (err) {
        // console.log(err);
      }
    }
  }
};
</script>

<style scoped>
.content-register-right {
  position: absolute;
  right: 0px;
  top: 20px;
  zoom: 80%;
}

@media only screen and (max-width: 1400px) and (min-width: 900px) {
  .__zoom-survey {
    zoom: 80%;
  }
}

@media only screen and (max-width: 1500px) and (min-width: 1400px) {
  .__zoom-survey {
    zoom: 85%;
  }
}

.img-banner-left {
  position: fixed;
}

.wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
}

.wrap img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  transform: translate(-50%, -50%);
}

@media only screen and (max-width: 900px) {
  .img-banner-left {
    display: none !important;
  }

  .content-register-right {
    position: relative !important;
    zoom: 83%;
    padding: 15px;
  }
  .wrap img {
    display: none !important;
  }
  .wrap {
    display: none !important;
  }
  .hide-image {
    display: none !important;
  }
}
</style>
